<template>
  <div class="ideas-content">
    <OpenEndedContent v-if="slide.votingStep === voteStep.SUBMISSION" />
    <IdeasVotingContent class="padding" v-else />
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import VoteStep from '@/constants/VoteStep'

import OpenEndedContent from '@/components/types/OpenEndedContent.vue'
import IdeasVotingContent from '@/components/types/IdeasVotingContent.vue'

export default {
  components: {
    OpenEndedContent,
    IdeasVotingContent,
  },
  data() {
    return {
      voteStep: VoteStep,
    }
  },
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
    }),
    ...mapGetters({
      slide: 'activeActivity',
    }),
  },
  mounted() {
    if (this.presentation.audiencePacing) {
      this.slide.votingStep = VoteStep.SUBMISSION
    }
  },
}
</script>
